import { patientsSagas } from 'common/utils/commonSagaCreators';
import { actionTypes } from '../reducer';

export const lockPatients = patientsSagas.createLockPatientSaga(
  actionTypes.lockPatients
);
export const unlockPatients = patientsSagas.createUnlockPatientSaga(
  actionTypes.unlockPatients
);
